export default "__VITE_ASSET__ceedbe70__"